<template>
    <div>
        <b-modal id="create" :title="uploadObject.Id ? 'Düzenle' : 'Ekle'" no-close-on-esc no-close-on-backdrop>
            <src-file-create v-model="uploadObject"></src-file-create>
            <template #modal-footer><v-executer :loading="loading" :action="upload">Kaydet</v-executer></template>
        </b-modal>


        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    :items-provider="provider"
                    pagination="server"
                    :settings="false"
                    :add-callback="createNew"></v-table>
    </div>
</template>

<script>
import SRCApi from '@/api/src-o'
import SRCFileCreate from './components/SRCFileCreate.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        'src-file-create':SRCFileCreate
    },
    props:{
        id:[String,Number],
    },
    data(){
        return {
            uploadObject:{
                Id:null,
                EmployeeId:this.id,
                SRCFileTypeId:null,
                FileRequired:false,
                StartDate:null,
                EndDate:null,
                File:null
            },
            fields:[
                {name:'Geçerli',key:'Valid'},
                {name:'Belge Türü',key:'SRCFileTypeName',thClass:'w-34'},
                {name:'Başlangıç Tarihi',key:'StartDateStr',thClass:'w-34'},
                {name:'Bitiş Tarihi',key:'EndDateStr',thClass:'w-34'}
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"success",action:this.download, condition:item => item.FilePath }
            ],
            loading:false
        }
    },
    methods:{
        clearForm(){
            this.uploadObject.Id = null
            this.uploadObject.EmployeeId = null
            this.uploadObject.SRCFileTypeId = null
            this.uploadObject.FileRequired = false
            this.uploadObject.StartDate = null
            this.uploadObject.EndDate = null
            this.uploadObject.File = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create')
        },
        provider(data){
            return SRCApi.Employee.Table({
                ...data,
                EmployeeId:this.id
            })
        },
        edit(item){
            this.clearForm()
            this.uploadObject.Id = item.Id
            this.uploadObject.EmployeeId = this.id
            this.uploadObject.SRCFileTypeId = item.SRCFileTypeId
            this.uploadObject.FileRequired = item.FileRequired
            this.uploadObject.StartDate = item.StartDate
            this.uploadObject.EndDate = item.EndDate
            this.uploadObject.File = item.FilePath
            this.$showModal('create')
        },
        upload(){
            const formData = new FormData()
            if(this.uploadObject.Id) formData.append('Id', this.uploadObject.Id)
            formData.append('EmployeeId',this.id)
            if(this.uploadObject.SRCFileTypeId != null) formData.append('SRCFileTypeId',this.uploadObject.SRCFileTypeId)
            if(this.uploadObject.StartDate) formData.append('StartDate',this.uploadObject.StartDate)
            if(this.uploadObject.EndDate) formData.append('EndDate',this.uploadObject.EndDate)
            
            if(this.uploadObject.File != null && typeof this.uploadObject.File === 'object') {
                formData.append('File',this.uploadObject.File)
            }
            
            this.loading = true
            const request = this.uploadObject.Id  
                ? SRCApi.Employee.Update(formData)  
                : SRCApi.Employee.Create(formData)
                
            request.then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create')
                }
                this.$result(res)
                this.loading = false
            }).catch(err => {
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.SRCFileTypeName} belge türündeki SRC belgesini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SRCApi.Employee.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        download(item){
            Additional.DownloadTab(item.FilePath)
        }
    }
}
</script>